import React from 'react';
import { Form } from 'react-form';
import { connect } from 'react-redux';
import _ from 'lodash';
import Translate from 'translate';

import { FormGroup, Text, Select, RadioButton } from 'components/FormElements/';
import { loginUser, toggleLoading, toggleAlertError } from 'stores/actions/';
import UserService from 'services/UserService';
import Modal from "react-responsive-modal";

class Settings extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: {}
    };
    this.submitForm = this.submitForm.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if( !this.props.open && nextProps.open ) {
      this.getData()
    }
  }

  getData() {
    const { userId, user } = this.props;
    let emailPass = '';
    try {
      emailPass = atob(user.emailPassword)
    } catch (error) {
      emailPass = user.emailPassword;
    }
    const data = {
      hostname : user.hostname,
      emailUsername : user.emailUsername,
      emailPassword : emailPass,
      clientVersion : user.clientVersion
    }
    this.setState( { data } );

    
  }

  submitForm( formData ) {
    const { userId, toggleAlertError, toggleLoading } = this.props;
    this.formData = _.cloneDeep( formData );

    toggleLoading( true );

    const data = {
      ...formData,
      afterDashboard: formData.openIn === 1,
      afterPanel: formData.openIn === 2,
    };

    UserService.updateUserEmailSettings( userId, formData ).then( ( response ) => {
      toggleLoading( false );
      if( !response.errors ) {
        const { hostname, emailUsername, emailPassword, clientVersion } = formData;
        this.props.loginUser( { hostname, emailUsername, emailPassword, clientVersion } );
        toggleAlertError( <Translate id="dataSaved"/> );
        return this.closeModal()
      } else {
        return toggleAlertError( response.errors );
      }
    } )
  }

  closeModal = () => {
    this.setState( { data: {} } );
    this.props.onClose()
  };

  render() {
    return (
      <Modal closeOnEsc={false}
             little
             modalClassName="col-md-5"
             open={this.props.open}
             onClose={this.closeModal}>
        <h5 className="mt-0"><Translate id="email.settings"/></h5>

        <div className="row">
          <div className="col-md-12">
            <Form
              onSubmit={this.submitForm}
              defaultValues={this.formData || this.state.data}
            >
              {( { submitForm } ) =>
                <form onSubmit={submitForm}>
                  <FormGroup>
                    <label><Translate id="hostname"/></label>
                    <Text field="hostname" className="form-control"/>
                  </FormGroup>
                  <FormGroup>
                    <label><Translate id="emailUsername"/></label>
                    <Text field="emailUsername" className="form-control"/>
                  </FormGroup>
                  <FormGroup>
                    <label><Translate id="password"/></label>
                    <Text field="emailPassword" type="password" className="form-control"/>
                  </FormGroup>
                  <FormGroup>
                    <label><Translate id="clientEchangeVersion"/></label>
                    <Select field="clientVersion" className="form-control"
                          options={[
                            { id: 'Exchange2007', name: 'Exchange 2007' },
                            { id: 'Exchange2007_SP1', name: 'Exchange 2007 SP1' },
                            { id: 'Exchange2009', name: 'Exchange 2009' },
                            { id: 'Exchange2010', name: 'Exchange 2010' },
                            { id: 'Exchange2010_SP1', name: 'Exchange 2010 SP1' },
                            { id: 'Exchange2010_SP2', name: 'Exchange 2010 SP2' },
                            { id: 'Exchange2013', name: 'Exchange 2013' },
                            { id: 'Exchange2013_SP1', name: 'Exchange 2013 SP1' },
                            { id: 'Exchange2016', name: 'Exchange 2016' },
                          ]}/>
                  </FormGroup>

                  <div className="text-right mt-4">
                    <button type="submit" className="btn btn-info px-4"><Translate id="save"/></button>
                  </div>
                </form>
              }
            </Form>
          </div>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = ( state, ownProps ) => ( {
  userId: state.user.id,
  user: state.user,
} );

const mapDispatchToProps = dispatch => ( {
  loginUser: ( user ) => {
    dispatch( loginUser( user ) );
  },
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( Settings );



// WEBPACK FOOTER //
// ./routes/app/components/Navigation/EmailSettingsModal/index.js